export const BASE_URL = 'https://api.solinics.com';
export const BYTE_RANGE_BASE_URL = BASE_URL + '/api/file-manager/stream';

export const INNER_VERSION = '1.18.2';
export const VERSION = '3.5.2';